import * as types from './mutation-types'
// import * as consts from '../util/const'

export default {
  [types.SET_USER_INFO](state, payload) {
    state.userInfo = payload
  },
  [types.UPDATE_CREDIT](state, payload) {
    state.userInfo.credit = payload
  },
  [types.SET_X_AUTH](state, payload) {
    state.xAuth = payload
  },
  [types.ENABLE_JSSDK](state) {
    state.jssdkEnabled = true
  },
  [types.DISABLE_JSSDK](state) {
    state.jssdkEnabled = false
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js